module.exports = __webpack_public_path__ + "img/jesse-signature-478x200.1c8548e.png";